import { CampaignHealthOption } from '../../../utils/types';

export const CAMPAIGN_HEALTH_OPTIONS: CampaignHealthOption[] = [
  // QC (Quality Control) Options
  { id: 'healthy-qc', name: 'Healthy (QC)', category: 'qc' },
  { id: 'unhealthy-qc', name: 'Unhealthy (QC)', category: 'qc' },
  
  // Stats/CR (Conversion Rate) Options
  { id: 'healthy-stats', name: 'Healthy (Stats/CR)', category: 'stats' },
  { id: 'broken-stats', name: 'Broken (Stats/CR)', category: 'stats' }
];

export default CAMPAIGN_HEALTH_OPTIONS;